import React from 'react';

export default function RechnungEmpfangenSection__elements9() {
    return (
        <React.Fragment>
            <>
                <h6 className="mb-4 text-base md:text-lg leading-tight text-darkCoolGray-900 font-bold tracking-tighter">Einmalige Einrichtungsgebühr EUR 890,--</h6>


            </>
        </React.Fragment>
    );
}

